import type { IContextualMenuItem, IContextualMenuProps } from '@fluentui/react/lib/ContextualMenu';
import type AssetCommandDescriptor from './AssetCommandDescriptor';

/**
 * Describes a command that is supported by an instance of an asset.
 */
interface AssetCommandBase extends AssetCommandDescriptor {
    readonly disabled?: boolean;
    readonly showOnSameTypeSelected?: boolean;
    readonly hidden?: boolean;
}

export interface AssetCommandButton extends AssetCommandBase {
    readonly onInvoke: () => void;
}

export interface AssetCommandMenu extends AssetCommandBase {
    readonly getMenuItems: () => IContextualMenuItem[];
    readonly getMenuProps?: () => Partial<IContextualMenuProps>;
}

export type AssetCommand = AssetCommandButton | AssetCommandMenu;

export function isCommandButton(command: AssetCommand): command is AssetCommandButton {
    return 'onInvoke' in command;
}
